import {Button, FlipList, Loading, setNotification} from '@startlibs/components';
import {formatDate, getColor, stopPropagation,getFetcher} from '@startlibs/utils';
import React, {useEffect, useRef, useState} from 'react'
import styled from 'styled-components/macro';

import {
  PanelButton,
  WidgetBody,
  WidgetFooter,
  WidgetHeader,
  WidgetPanelComponent
} from './PanelStyles';

import {touchClick} from './utils'
import {usePanelUtils2} from './usePanelUtils2'
// import {RecordStatus} from '../lib/utils/recordEnums'
// import {useUploadLog} from '../lib/service/uploadLog'
import {UNARCHIVED, UNARCHIVING, UNARCHIVING_FAILED, getDate} from '../../utils/utils'
import { UnarchivingItem } from './UnarchivingItem';

const IgnoredFilesWarning = styled.div`
  padding: 1rem;
  background: ${getColor('gray240')};
  border-radius: 6px;
  margin-bottom: 0.75rem;
  font-weight: bold;
  font-size: 13px;
  .link {
    font-size: 12px;
    margin-left: 0.25rem;
  }
`

export const UnarchivingPanel = ({unarchivingWorklist, setUnarchivingWorklist, close, setInvalidateCache}) => {
  
  const [{refs}, maximized, toggleMaximized, isRefocusingPanel, isHighlighting] = usePanelUtils2()
  const panelRef = refs.panel
  const scrollContainerRef = refs.scrollContainer
  const timeoutIdsRef = useRef({});
  const [isUnarchiving, setIsUnarchiving] = useState(false);

  useEffect(() => {

      // Clear previous timeouts
      Object.values(timeoutIdsRef.current).forEach(clearTimeout);
      timeoutIdsRef.current = {};
      setIsUnarchiving(true);  // Reset unarchiving flag
  
      if (unarchivingWorklist && unarchivingWorklist.length > 0) {
          unarchivingWorklist.forEach((study) => {
              if (study.study.rotate_status === UNARCHIVING) {
                  // const studyUid = study.tools.dicomEditWeblink.split("study_iuid=")[1];
                  const studyUid = study.study.iuid;
  
                  const checkUnarchiveStatus = () => {
                      getFetcher('/StudyRotateStatus.php?id_study=' + studyUid)
                          .then((response) => {
                              // ...
  
                              // If we need to check again, we store the timeoutId
                              if (response.rotate_status !== UNARCHIVED && response.rotate_status !== UNARCHIVING_FAILED) {
                                  timeoutIdsRef.current[studyUid] = setTimeout(
                                      checkUnarchiveStatus,
                                      8000
                                  );
                              } else {
                                  // set study as unarchived
                                  setUnarchivingWorklist((prev) =>
                                      prev.map((study) => {
                                          if (study.study.iuid === studyUid) {
                                              return {
                                                  ...study,
                                                  study: {
                                                      ...study.study,
                                                      rotate_status: response.rotate_status,
                                                  },
                                              };
                                          }
                                          return study;
                                      })
                                  );
                                  setInvalidateCache(true);
                                  // We clear the timeoutId when no longer needed
                                  delete timeoutIdsRef.current[studyUid];
                              }
                              
                          })
                          .catch((e) => {
                              console.log('error', e);
                          });
                  };
  
                  // We store the initial timeoutId if it has not been stored yet
                  if (!timeoutIdsRef.current[studyUid]){
                    timeoutIdsRef.current[studyUid] = setTimeout(
                        checkUnarchiveStatus,
                        8000
                    );
                  }
              }
          });
      }

      // Check if any other study is still being unarchived
      const isAnyStudyStillUnarchiving = unarchivingWorklist.some(
          (study) => study.study.rotate_status === UNARCHIVING
      );
      setIsUnarchiving(isAnyStudyStillUnarchiving);
  
      return () => {
          // On cleanup, we clear all timeouts
          Object.values(timeoutIdsRef.current).forEach(clearTimeout);
      };
  }, [unarchivingWorklist]); // Add maximized to the dependencies array
  
  useEffect(() => {
    unarchivingWorklist && unarchivingWorklist.length > 0 && toggleMaximized(true)
  },[])
  

  const todayDate = formatDate(getDate(0), "yyyy-MM-dd",null, true)

  return <WidgetPanelComponent
    className="JS-fix-dialog-scroll" maximized={maximized} ref={panelRef}
  >
   
    <WidgetHeader onClick={toggleMaximized} onTouchStart={touchClick(toggleMaximized)}>
      {isUnarchiving && <Loading white/>}
      <div css="margin-right:auto;">
        {
          isUnarchiving
            ? <h4>Unarchiving studies</h4>
            : <h4>All studies unarchived</h4>
        }
      </div>
      {maximized && <>
        <PanelButton icon="arrow-down-line"/>
        <PanelButton icon="x" onClick={() => close()} />
      </>
      }
    </WidgetHeader>
    <WidgetBody ref={scrollContainerRef}>
      {unarchivingWorklist && unarchivingWorklist.length > 0 
        ? <FlipList>
            {unarchivingWorklist &&  unarchivingWorklist.map((study, idx) => 
                <UnarchivingItem key={idx} study={study} setUnarchivingWorklist={setUnarchivingWorklist} />)
            } 
          </FlipList> 
        : <div css="text-align:center; padding: 1rem;">
          <p>No studies being unarchived</p>
        </div>
      }
    </WidgetBody>
    {/* <WidgetFooter>
      <Button.Link css="width:100%;" outline highlight to={`?page=1&uploadDateInit=${todayDate}&uploadDateEnd=${todayDate}`}>
        Show studies unarchived recently
      </Button.Link>
    </WidgetFooter> */}
  </WidgetPanelComponent>
}